module.exports = __webpack_public_path__ + "src/assets/static/img/loader.cfa9caaf.svg";